import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    if (lenis) return lenis;
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return lenis;
}

export function scrollToId(id) {
    const target = document.querySelector(id);
    if (!target) return;
    if (lenis) {
        lenis.scrollTo(target, { offset: -72, duration: 1.4 });
    } else {
        target.scrollIntoView({ behavior: "smooth" });
    }
}
